export default {
  path: "/HighlightedTopic/HitAndRun",
  name: "Highlighted Topic - Hit & Run/Unknown Person",
  type: "highlightedTopic",
  htmlContent: "HT-HitAndRun.html",
  keyPoints: [
    "Supplemented Reports: If the Hit & Run/Unknown Person is later identified, then a supplemented crash report should be completed as additional information is available. The Hit & Run flag should remain, and the officer should notate in the <u>Narrative</u> that the crash was initially a Hit and Run crash, but the driver or vehicle was later identified and the date it was identified. ",
  ],
  scenarios: [
    {
      name: "Original & Supplemented Narratives vs. Clear and Supplemented Narratives",
      description: `<p><strong>Original Narrative: </strong></p>
<p>Based on the physical evidence and statement from the driver the following was determined. Vehicle #2 was traveling
    eastbound on N Druid Hills Rd toward Mistletoe Rd when vehicle #1 turned out from Mistletoe Rd and struck vehicle
    #2. </p>
<p>Driver #1 fled the scene of the accident without providing any identifying information. Driver #2 stated that it
    appeared that vehicle #1 was running away from someone. </p>
<p>No injuries were reported. Driver #2 was provided a case number and advised on how to obtain a copy of the report. 
</p>
<p>Body Worn Available. </p>
<p><strong>Original Supplemented Narrative:</strong> </p>
<p>Based on the physical evidence and statement from the driver the following was determined. Vehicle #2 was traveling
    eastbound on N Druid Hills Rd toward Mistletoe Rd when vehicle #1 turned out from Mistletoe Rd and struck vehicle
    #2. </p>
<p>Driver #1 fled the scene of the accident without providing any identifying information. Driver #2 stated that it
    appeared that vehicle #1 was running away from someone. </p>
<p>No injuries were reported. Driver #2 was provided a case number and advised on how to obtain a copy of the report. 
</p>
<p>Due to driver #2's description of vehicle #1 as well as a DA Investigator's statement from an accident scene nearby
    the hit and run vehicle was identified and added to the hit and run card. Refer to case number 23-037649 for
    further. </p>
<p>Body Worn Available. </p>
<p><strong>Clear Narrative: </strong></p>
<p>I arrived at the location of an <strong>angle crash</strong> at the <strong>Signal Controlled intersection</strong>
    of N Druid Hills Rd at Mistletoe Rd. Unit #1 was turning left from Mistletoe Rd, onto N. Druid Hills Rd west bound.
    Unit #2 was traveling eastbound on N Druid Hills Rd toward Mistletoe Rd. </p>
<p><strong>Driver #1</strong> fled the scene of the crash in Unit #1 without providing any identifying information.  
</p>
<p><strong>Driver #2</strong> stated that it appeared that Unit #1 was running away from someone and observed Unit #1
    enter the intersection <strong>without stopping at the red traffic signal</strong> and crossing in front of Unit
    #2. Driver #2 provided a description of the vehicle as a black two door Mercedes Benz with a tag number starting
    with ADC4, Georgia plate. </p>
<p><strong>Injuries:</strong> No injuries were reported.  </p>
<p><strong>Officer Investigation:</strong> The front right of Unit #2 struck the front left of Unit #1 as Unit #1
    <strong>failed to yield</strong> and <strong>disregarded the signal</strong> while entering the roadway. Following
    the crash Driver #1 fled the scene heading north on Mistletoe Rd.  
</p>
<p><strong>Vehicle Conditions: </strong>Unit #1 was not located at the time of reporting, and Unit #2 following a brief
    inspection, appeared to be in good working conditions with adequate tire tread. Based on the inspection there are
    <strong>no vehicle contributing factors</strong>.  
</p>
<p><strong>Roadway Conditions:</strong> N Druid Hills Rd. is a four-lane divided roadway as shown in the diagram with
    <strong>clearly visible pavement markings</strong> with a<strong> </strong><strong>posted speed limit of 45
        mph</strong><strong>. </strong>and a right and left turn lanes for Mistletoe Rd. Rd. The road was <strong>dry
        and in good condition</strong> at the time of the crash. Mistletoe Rd. onto N Druid Hills Rd. has a clearly
    visible <strong>traffic signal</strong> in good repair including a<strong> </strong><strong>left turn
        signal</strong>. The roadway has a clearly visible <strong>stop bar</strong>. There are <strong>no obstructions
        blocking visibility</strong> for vehicles approaching the intersection. Based on these conditions, there are
    <strong>no roadway contributing factors.  </strong>
</p>
<p> </p>
<p><strong>Clear Supplemented Narrative: </strong></p>
<p>The Original Narrative<strong> </strong><strong>is unchanged</strong> with the following <strong>updates</strong>:
    the hit and run vehicle was identified on 05/15/2023 and the information was updated in the applicable Unit #1 data
    fields in this report.  </p>
<p><i>Note: always update all applicable reports with complete Information. The affected parties need access to the
    information to resolve/settle their claims. Never direct an impacted party to reference another report or document
    to ascertain required missing report information. Statements like these are <strong>unacceptable</strong>:  …the hit
    and run vehicle was identified and added to the hit and run card. Refer to case number 23-037649.</i>  </p>`,
    },
  ],
  keywords: ["Fled", "Left", "Unknown", "Hit", "Run", "Unknown"],
};
